import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-migliorioffertehome',
  templateUrl: './migliorioffertehome.component.html',
  styleUrls: ['./migliorioffertehome.component.scss']
})
export class MigliorioffertehomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/migliorioffertehome/migliorioffertehome.component.ts